/*
Guest wishlist: loads cards on the public wishlist page (from localStorage,
via the Section Rendering API), and syncs a guest's saved products into their
real account once they log in. Depends on the guest-storage helpers
(window.getGuestWishlist / removeFromGuestWishlist) defined in
snippets/frenzy-callback-function.liquid, which loads on every page.
*/

(function () {
  const WISHLIST_API_BASE = 'https://beachriot-wishlist-app.vercel.app/api/beach-riot/wishlist';

  async function loadGuestWishlistCards() {
    const grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    const items = window.getGuestWishlist ? window.getGuestWishlist() : [];
    if (items.length === 0) {
      grid.innerHTML = '<p class="guest-wishlist-empty col-span-full">Your wishlist is empty.</p>';
      document.querySelector('wishlist-filters')?.refresh();
      return;
    }

    const results = await Promise.allSettled(
      items.map((item) =>
        fetch(`/products/${item.handle}?sections=product-item-small-section`).then((res) => res.json()),
      ),
    );

    grid.innerHTML = '';
    results.forEach((result) => {
      if (result.status === 'fulfilled' && result.value['product-item-small-section']) {
        const wrapper = document.createElement('div');
        wrapper.className = 'col-span-1 relative';
        wrapper.innerHTML = result.value['product-item-small-section'];
        grid.appendChild(wrapper);
      }
    });

    document.querySelector('wishlist-filters')?.refresh();
  }

  async function syncOneProduct(customerId, item) {
    const statusRes = await fetch(`${WISHLIST_API_BASE}/${customerId}/${item.id}`);
    const statusData = await statusRes.json();
    if (statusData?.data?.isProductWishlisted) return; // already in the account, nothing to do

    const toggleRes = await fetch(`${WISHLIST_API_BASE}/${customerId}/${item.id}/toggle`);
    if (!toggleRes.ok) throw new Error(`Sync failed for product ${item.id}`);
  }

  // Synced one at a time (not in parallel): the wishlist API does a
  // read-modify-write on the customer's wishlist metafield, so concurrent
  // toggle calls race and overwrite each other, silently dropping items.
  // Never lets one failure block the rest; items that fail stay in
  // localStorage for a manual retry.
  async function syncGuestWishlistOnLogin(customerId) {
    const pending = window.getGuestWishlist ? window.getGuestWishlist() : [];
    if (!customerId || pending.length === 0) return { synced: [], failed: [] };

    const synced = [];
    const failed = [];

    for (const item of pending) {
      try {
        await syncOneProduct(customerId, item);
        synced.push(item);
        window.removeFromGuestWishlist(item.id);
      } catch (error) {
        failed.push(item);
      }
    }

    return { synced, failed };
  }

  window.loadGuestWishlistCards = loadGuestWishlistCards;
  window.syncGuestWishlistOnLogin = syncGuestWishlistOnLogin;
})();
